<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <h1 class="text-title-underline">{{ t('bookmark.title') }}</h1>
        <template v-if="Array.isArray(bookmarks) && bookmarks.length">
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
            <div v-for="bookmark in pagedList" :key="bookmark.id">
              <template v-if="bookmark.video">
                <router-link
                  :to="`/video/${bookmark.video.id}`"
                >
                  <video-thumbnail :video="bookmark.video" />
                </router-link>
              </template>
            </div>
          </div>
          <div class="flex items-center justify-center mt-10">
            <base-pagination v-model:pagedList="pagedList" :originalList="bookmarks" :pageSize="pageSize" />
          </div>
        </template>
        <template v-else>
          動画が見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { VideoBookmarkAttributes } from '@/types/models/video-bookmark'
import { axios, ApiResponse } from '@/plugins/axios'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BasePagination from '@/components/BasePagination.vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BasePagination,
    VideoThumbnail
  },
  setup() {
    const { t } = useI18n()
    const bookmarks = ref<VideoBookmarkAttributes[]>([])
    const pageSize = ref(10)
    const pagedList = ref<VideoBookmarkAttributes[]>([])

    onMounted(() => {
      axios.get<ApiResponse<VideoBookmarkAttributes[]>>('/video/bookmark')
        .then(response => {
          bookmarks.value = response.data.payload
        })
    })

    return {
      t,
      bookmarks,
      pageSize,
      pagedList
    }
  }
})
</script>
